// extracted by mini-css-extract-plugin
export default {"wrapper":"uB-z","viewport":"vB-z","container":"wB-z","slide":"xB-z"};